import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";
import Screenshot from "@/components/help/Screenshot";
import { Card, CardContent } from "@/components/ui/card";

function FeeBreakdown() {
  return (
    <Card>
      <CardContent className="p-5 space-y-2 text-sm">
        <div className="flex justify-between">
          <span>Donation</span>
          <span className="font-mono tabular-nums">$50.00</span>
        </div>
        <div className="flex justify-between text-muted-foreground items-center">
          <span className="flex items-center gap-2">
            <span className="h-3.5 w-3.5 rounded border border-primary bg-primary/20" />
            Add $1.75 to cover the card fee
          </span>
          <span className="font-mono tabular-nums">+ $1.75</span>
        </div>
        <div className="border-t border-border pt-2 flex justify-between font-medium">
          <span>You'll be charged</span>
          <span className="font-mono tabular-nums">$51.75</span>
        </div>
        <div className="flex justify-between text-success">
          <span>School receives</span>
          <span className="font-mono tabular-nums">$50.00</span>
        </div>
      </CardContent>
    </Card>
  );
}

export default function CoveringProcessingFees() {
  return (
    <>
      <p>
        Card transactions cost a small fee — about <strong>2.8% + 30¢</strong> on a Canadian online donation. If you tick the box to cover the card fee at checkout, you pay that extra dollar or two and the school gets your whole donation. If you don't, the school still gets your donation, just with that fee taken off the top.
      </p>

      <Screenshot caption="What it looks like at checkout">
        <div className="max-w-md mx-auto">
          <FeeBreakdown />
        </div>
      </Screenshot>

      <p>
        For example: a $50 donation with the fee covered means you pay $51.75, and the school gets the full $50. Without the fee covered, you pay $50 and the school gets about $48.30.
      </p>

      <Callout variant="tip" title="Most donors leave it checked">
        <p>
          About 80% do — the extra dollar or two feels small compared to the donation, and it lands cleanly. But either way is fine. The school appreciates you no matter what you pick.
        </p>
      </Callout>

      <p>
        That fee goes to Square (the company that processes the card), not to PagePledge. We charge schools a flat fee per campaign — we never take a cut of donations.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/making-a-donation">How to make a donation</Link>.</li>
        <li><Link href="/help/articles/donor-receipts-and-refunds">Receipts and refunds</Link>.</li>
      </ul>
    </>
  );
}
